import { useEffect } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { MdFace, MdVpnKey } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { signInStart } from 'redux/user/user.action';
import Paths from 'util/paths';
import string from 'util/string';
import { focusElement, getFormData, showToast } from 'util/utils';
import { FaChevronRight } from 'react-icons/fa';
import AlincoLogo from 'asset/img/alinco_logo.png';
import './Login.scss';

const LoginText = ({ type = 'text', id, placeholder, Icon }) => {
  const props = { id, name: id, type };
  if (placeholder) {
    props['placeholder'] = placeholder;
  }

  return (
    <InputGroup>
      {!!Icon && (
        <InputGroup.Text>
          <Icon />
        </InputGroup.Text>
      )}
      <Form.Control {...props} />
    </InputGroup>
  );
};

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // history.push(Urls.user.login);
    let loginTimeout = setTimeout(() => {
      history.push(Paths.root);
    }, 100);
    return () => {
      if (loginTimeout) {
        clearTimeout(loginTimeout);
      }
    };
		/* eslint-disable react-hooks/exhaustive-deps */
  }, []);

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		focusElement('#email');
	// 	},10);
	// },[]);

  const onSubmit = async (e) => {
    // console.log(e);
    e.preventDefault();
    e.stopPropagation();
    // console.log(getFormData(e.target));
    let formData = getFormData(e.target, {
      rawCol: {
        email: true,
        password: true,
      },
    });
    if (!formData?.email) {
      showToast(string.LOGIN_ID_EMPTY_ERR);
      focusElement('#email');
      return;
    }
    if (!formData?.password) {
      showToast(string.PASSWORD_EMPTY_ERR);
      focusElement('#password');
      return;
    }
    await dispatch(signInStart(formData));
    history.push(Paths.root);
    return false;
  };

  return (
    <>
      <div className="screen-login">
        <div className="wrapper fadeInDown">
					<div id='logoBox'>
						<img
							alt="layout"
							width="60%"
							height="60%"
							src={AlincoLogo}
						/>
					</div>
          <div id="formContent">
            <h2 className="active">{string.TITLE_JP}</h2>
            <div className="card-body">
              <Form onSubmit={onSubmit}>
                <LoginText
                  id="email"
                  Icon={MdFace}
                  placeholder={string.LOGIN_ID}
                />
                <LoginText
                  id="password"
                  Icon={MdVpnKey}
                  type="password"
                  placeholder={string.PASSWORD}
                />
                <Button type="submit">{string.LOG_IN}</Button>{' '}
								{/* <div>
									{string.LOG_IN_DETAILS}
								</div> */}
								<div id="formContent3">
									{string.LOG_IN_DETAILS}
								</div>
                <div id="formContent2">
                  <a
                    className="underlineHover"
                    href={Paths.user.forgetPassword}
                  >
                    {string.FORGET_PASSWORD + ' '}
                    <FaChevronRight />
                  </a>
                </div>
                <div id="formFooter">
                  <a className="underlineHover" href={Paths.user.signup}>
                    {string.SIGNUP + ' '}
                    <FaChevronRight />
                  </a>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
